export default __webpack_public_path__ + "static/media/person.3ff5a362.svg";